export const getCanonicalUrl = (path) => {
    const PROD_DOMAIN = 'https://rbw.com';

    return PROD_DOMAIN + path;
};

export const isParameterizedURL = (params) => !!params;
